import { render, staticRenderFns } from "./AdminRetailerMargin.vue?vue&type=template&id=22da578e&scoped=true&lang=pug"
import script from "./AdminRetailerMargin.vue?vue&type=script&lang=js"
export * from "./AdminRetailerMargin.vue?vue&type=script&lang=js"
import style0 from "./AdminRetailerMargin.vue?vue&type=style&index=0&id=22da578e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da578e",
  null
  
)

export default component.exports